export enum OrderCopyOrderErrorEnum {
  OrderNotFound = 'order_not_found',
  OrderTypeUnavailable = 'order_type_unavailable',
  OrderTypeNotDuplicatable = 'order_type_not_duplicatable',
  AssortmentFetchFailed = 'assortment_fetch_failed',
  DraftCreationFailed = 'draft_creation_failed',
  NoAssortmentAvailable = 'no_assortment_available',
}
